/**
 * Angular Application for Client interface
 */
var app = angular.module('appClient', [
    'ngCookies',
    'pascalprecht.translate',	// translation
    'tmh.dynamicLocale',	// translation
    'ngRoute',
    'ngTouch',
    'oc.lazyLoad',
    'angular.filter',
    'googlechart',
    'ui.router',
    'ui.router.stateHelper',
    'ui.grid',
    'ui.grid.cellNav',
    'ui.grid.moveColumns',
    'ui.grid.autoResize',
    'ui.grid.resizeColumns',
    'ui.grid.edit',
    'ui.grid.pagination',
    'ui.grid.grouping',
    'ngMap',
    'RecursionHelper',
    'RecursionHelper',
    'ngSanitize',
    '720kb.datepicker',
    'ngFileUpload'
]);


/* ----- TRANSLATE LANG ----- */

// Pour la selection des langues
app.constant('LOCALES', {
    'locales': {
        'fr-fr': {
            'country': 'france',
            'language': 'Français',
            'short_locale': 'fr'
        },
        'en-us': {
            'country': 'united kingdom',
            'language': 'English',
            'short_locale': 'en'
        },
        'es-es': {
            'country': 'spain',
            'language': 'Español',
            'short_locale': 'es'
        }
    },
    'preferredLocale': 'fr-fr'
});


app.config(['$translateProvider', 'tmhDynamicLocaleProvider', '$qProvider', function ($translateProvider, tmhDynamicLocaleProvider, $qProvider) {
    // Chargement asynchrone des trads
    //$translateProvider.useMissingTranslationHandlerLog();// Pour avoir un msg d'alerte dans la console si pas de trad trouvée
    $translateProvider.useSanitizeValueStrategy('escapeParameters');
    $translateProvider.useStaticFilesLoader({
        files: [{
            prefix: '/lang/translations-app/locale_',
            suffix: '.json'
        }, {
            prefix: '/lang/translations-bdd/locale_',
            suffix: '.json'
        }]
    });

    $translateProvider.preferredLanguage('fr-fr');	// local par defaut
    $translateProvider.fallbackLanguage('fr-fr');
    $translateProvider.useLocalStorage(); // sauvegarde de la langue en localStorage
    tmhDynamicLocaleProvider.localeLocationPattern('/lang/locales-i18n/angular-locale_{{ locale }}.js');// dynamic translate

    // Ne plus afficher les erreurs de reject :
    $qProvider.errorOnUnhandledRejections(false);
}]);

app.run(['$rootScope', '$state', '$window', function ($rootScope, $state, $window) {
    $rootScope.$on('$stateChangeStart', function (e, to, params) {
        $rootScope.goBack = function () {
            $window.history.back();
        };


        if (angular.isDefined(to.redirectTo)) {
            e.preventDefault();

            $state.go(to.redirectTo, params)
        }
    });
}]);